import * as Scrivito from "scrivito";

Scrivito.provideEditingConfig("ImageFooterWidget", {
  title: "Image footer widget",
  attributes: {
    link: {
      title: "Link (optional)",
      description: "The page to open after clicking the image.",
    },
  },
  properties: ["image", "title", "text", "link"],
  validations: [
    [
      "image",
      (image) => {
        if (!image) {
          return {
            message: "The image should be set.",
            severity: "warning",
          };
        }
      },
    ],
  ],
});
